<template>
  <div id="dashboard_page" class="centered" >

      <div id="linktones_list">
          <h3>הלינקטונים שלי</h3>
        <div v-if="loaded" class="sum_linkton">מספר לינקטונים : {{items.length}}</div>

        <div id="items_table" v-if="loaded">
            <div v-for="item in items" :key="item.id">
                <ItemStrip :item="item" @play="$emit('play', item)" @open_widget="$emit('open_widget', item)" :active="(item.opened ? 'active' : '') " @itemOpen="item.opened = !item.opened" />

                <ItemStats v-if="item.opened" :item="item" :id="item.id" />

            </div>

          <div class="clr"></div>
    
      </div>
      
    </div>

      <Loader v-if="on_loading" />
  </div>
</template>

<script>

import ItemStrip from '@/components/item_strip_stats.vue';
import ItemStats from '@/components/item_stats.vue';
import Loader from '@/components/loader.vue';


export default {
    components: {  ItemStrip, ItemStats,Loader },
  data(){
    return {
      loaded: false,
      on_loading: false,
      items: [
      ],
    }
  },

  mounted(){
    this.on_loading = true;
    this.api({ action: 'stats_main' }, (data) => { 
    
      for (let i in data.data.items)
      {
          data.data.items[i].opened = false;
          if (this.$route.params.id == data.data.items[i].id) data.data.items[i].opened = true;
      }

      this.items = data.data.items;
      this.loaded = true;
      this.on_loading = false;
    });

  }
  
}
</script>

<style lang="scss" scoped>
h3{font-size: 25px;margin-bottom: 11px;}
.sum_linkton{color: #a2a2a2;font-size: 25px;margin-bottom: 15px;}
</style>